import { useEffect, useState } from "react";
import { Share, X, Plus } from "lucide-react";

export const InstallTip = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("installtip_dismissed")) return;
    const ua = window.navigator.userAgent || "";
    const isIOS =
      /iphone|ipad|ipod/i.test(ua) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
    const isSafari = !/crios|fxios|edgios/i.test(ua); // iOS Chrome/Firefox/Edge can't add to home screen
    const standalone =
      window.navigator.standalone === true ||
      window.matchMedia("(display-mode: standalone)").matches;
    if (isIOS && isSafari && !standalone) {
      const t = setTimeout(() => setShow(true), 2500);
      return () => clearTimeout(t);
    }
  }, []);

  const dismiss = () => {
    localStorage.setItem("installtip_dismissed", "1");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="ios-install-tip"
      className="fixed left-3 right-3 bottom-24 md:bottom-6 md:left-auto md:right-6 md:max-w-sm z-50 animate-fade-up"
    >
      <div className="bg-charcoal text-cream rounded-2xl shadow-xl p-4 flex items-start gap-3">
        <span className="w-9 h-9 rounded-xl bg-coral flex items-center justify-center shrink-0">
          <Plus size={18} />
        </span>
        <div className="flex-1 text-sm leading-relaxed">
          <p className="font-semibold">Add Write My Story to your Home Screen</p>
          <p className="text-cream/80 mt-0.5">
            Tap <Share size={14} className="inline -mt-0.5" /> below, then choose{" "}
            <span className="font-semibold">"Add to Home Screen"</span> for a full-screen, app-like experience.
          </p>
        </div>
        <button
          data-testid="ios-install-dismiss"
          onClick={dismiss}
          className="text-cream/60 hover:text-cream shrink-0"
          aria-label="Dismiss"
        >
          <X size={18} />
        </button>
      </div>
    </div>
  );
};
